module.exports = __webpack_public_path__ + "static/media/starry-night@2x.df407e63.jpg";